import React, { useState, useEffect } from 'react'
import { Download } from 'lucide-react'
import { useSelector } from "react-redux";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table'
import { Button, buttonVariants } from '../../ui/button'
import { cn } from '../../lib/utils'
import { useDispatch } from 'react-redux'
import { getAffArtwork, setArtworkItems, setArtworkRecords, setArtworkVisible, setArtwork_page } from './AffiliateSlice'
import NoDataFound from '../Common/table/NoDataFound';
import { exportPDFC } from '../../sharedfiles/pdfExport';
import Vpagination from '../../sharedfiles/Vpagination';
import Tooltips from '../Common/Tooltip';
import { getDateTimeFormate } from '../../sharedfiles/helper';
import { useColumnPreferences } from '../../sharedfiles/hooks/useColumnPreferences';
import TableToolbar from "../Common/table/TableToolbar";

const ArtworkPopup = (props) => {
    const dispatch = useDispatch()
    const [csvData, setCsvData] = useState([])
    const [pdfBody, setPdfBody] = useState([])
    const [image, setImage] = useState("")
    const [imagePopup, setImagePopup] = useState(false)
    const artworlList = useSelector((p) => p.affiliateSlice.getUploadFiles)

    const paginationFirstValue = useSelector((p) => p.affiliateSlice.artwork_page)
    const paginationSecondValue = useSelector((p) => p.affiliateSlice.artworkItems)
    const recordsToShow = useSelector((p) => p.affiliateSlice.artworkRecords)
    const isVisible = useSelector((p) => p.affiliateSlice.artworkVisible)

    useEffect(() => {
        dispatch(getAffArtwork(0, 25))
    }, [])
    const tHeader = [
        [
            "S.No",
            "Artwork Name",
            "Updated On",
            "Updated By"
        ]
    ]
    const tableHeader = [
        "S.No",
        "Artwork Name",
        "Updated On",
        "Updated By",
        "Action Items"
    ]
    const artworkInfo = [
        "Showing S.No",
        "Showing Artwork Name",
        "Showing Updated On",
        "Showing Updated By",
        "Showing Action Items"
    ]
    const update = () => {
        const tBody = artworlList &&
            artworlList.data &&
            Array.isArray(artworlList.data)
            ? artworlList.data.map((p) => [p.id, p.docName?.split(".")[0], getDateTimeFormate(p.updated_date), p.updatedBy])
            : [];
        setPdfBody(tBody);
        const data = Array.isArray(tBody) && tBody.length > 0 ? [tHeader[0], ...tBody] : [tHeader[0], []];
        setCsvData(data);

    }
    useEffect(() => {
        update()
    }, [artworlList])
    const exportPDF = () => {
        const title = "Artwork Report";
        const styles = {
            4: {
                halign: "right",
                valign: "middle",
            },
        };
        exportPDFC(title, tHeader, pdfBody, styles);
    }
    const callPageApi = (pageNumber, itemsPerPage) => {
        dispatch(setArtworkVisible(true));
        dispatch(getAffArtwork(pageNumber - 1, itemsPerPage))
    }

    const onViewBtn = (img) => {
        console.log(img);
        setImagePopup(true)
        setImage(img)
    }
    const artworkRowAccessors = [
        (item) => item.id,
        (item) => item.docName?.split(".")[0],
        (item) => getDateTimeFormate(item.updated_date),
        (item) => item.updatedBy,
        (item) => (
            <div className='flex items-center gap-2'>
                <span
                    id="onArtworkViewBtn"
                    onClick={() => onViewBtn(item.docPath)}
                    className={cn(buttonVariants({ variant: "default", size: "sm" }), "cursor-pointer")}
                >
                    View
                </span>
                <Button
                    variant="outline"
                    size="sm"
                    asChild
                >
                    <a href={item.docPath} download>
                        <Download size={16} />
                    </a>
                </Button>
            </div>
        ),
    ];
    const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
        useColumnPreferences("affiliateArtworkPopup", tableHeader);
    return (
        <>
            <Dialog open={imagePopup} onOpenChange={setImagePopup}>
                <DialogContent className="sm:max-w-sm">
                    <DialogHeader>
                        <DialogTitle>Artwork</DialogTitle>
                    </DialogHeader>
                    <div className='flex justify-center items-center h-60'>
                        <img src={image} alt="Artwork Preview" loading="lazy" />
                    </div>
                </DialogContent>
            </Dialog>
            <Dialog open={props.openArtwork} onOpenChange={props.setOpenArtwork}>
                <DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
                    <DialogHeader>
                        <DialogTitle>Artwork Details</DialogTitle>
                    </DialogHeader>
                    <div className="overflow-y-auto flex-1">
                        <div className='space-y-4'>
                            {artworlList.totalRecords > paginationSecondValue && (
                                <Vpagination
                                    data={artworlList.data}
                                    totalRecords={artworlList.totalRecords}
                                    paginationFirstValue={paginationFirstValue}
                                    paginationSecondValue={paginationSecondValue}
                                    setPaginationFirstValue={setArtwork_page}
                                    setPaginationSecondValue={setArtworkItems}
                                    recordsShow={recordsToShow}
                                    setRecordsShow={setArtworkRecords}
                                    isVisible={isVisible}
                                    setIsVisible={setArtworkVisible}
                                    csvData={csvData}
                                    exportPDF={exportPDF}
                                    callApi={callPageApi}
                                    csvFileName={"Artwork Report"}
                                    reloadRequired={false}
                                    hideDocs
                                />
                            )}

                            <div className='space-y-4'>
                                <div className='relative rounded-md border overflow-x-auto'>
                                    <TableToolbar
                                        columns={allColumns}
                                        onToggle={toggleVisibility}
                                        onReorder={reorder}
                                        onReset={resetToDefault}
                                    />
                                    <Table scrollKey="affiliateArtworkPopup">
                                        <TableHeader>
                                            <TableRow>
                                                {
                                                    visibleIndices.map((origIdx) => (
                                                        <TableHead key={origIdx}>
                                                            <div className='flex justify-center items-center gap-1'>
                                                                <p>{tableHeader[origIdx]}</p>
                                                                <Tooltips info={`${artworkInfo[origIdx]}`} />
                                                            </div>
                                                        </TableHead>
                                                    ))
                                                }
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                            {artworlList &&
                                                artworlList.data && artworlList.data.length > 0 ? (
                                                artworlList.data.map((item, ind) => {
                                                    return (
                                                        <TableRow key={ind}>
                                                            {visibleIndices.map((origIdx) => (
                                                                <TableCell key={origIdx} className='text-center whitespace-nowrap'>
                                                                    {artworkRowAccessors[origIdx](item)}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    )

                                                })
                                            ) : (
                                                <NoDataFound colspan={visibleIndices.length} />
                                            )
                                            }
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ArtworkPopup